import { ReactNode, useCallback } from "react";

import { ShowOptions } from "./messages/Messages";
import { useSnackbarContext } from "./SnackbarContext";

export const useSnackbar = () => {
  const showSnackbar = useSnackbarContext();

  // Since showSnackbar is already stable from context, we can create these callbacks directly
  const showInfo = useCallback(
    (message: ReactNode, options?: ShowOptions) =>
      showSnackbar?.("info", message, options),
    [showSnackbar],
  );

  const showError = useCallback(
    (message: ReactNode, options?: ShowOptions) =>
      showSnackbar?.("error", message, options),
    [showSnackbar],
  );

  const showWarning = useCallback(
    (message: ReactNode, options?: ShowOptions) =>
      showSnackbar?.("warning", message, options),
    [showSnackbar],
  );

  const showSuccess = useCallback(
    (message: ReactNode, options?: ShowOptions) =>
      showSnackbar?.("success", message, options),
    [showSnackbar],
  );

  return {
    showInfo,
    showError,
    showWarning,
    showSuccess,
  };
};
